import React, { useEffect, useState } from "react";
import { fetchAvailabilityDocuments } from "./adminUtils";

import AddIcon from "@mui/icons-material/Add";
import { fetchDailyPrices } from "../../firebaseConfig";
import CalendarBooking from "./CalendarBooking";
import {
  Typography,
  Stack,
  Box,
  useMediaQuery,
  Tabs,
  Tab,
  Grid,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import useTranslatedRooms from "../../utils/rooms";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import TabManageBookings from "./TabManageBookings";
import { EuroSymbol } from "@mui/icons-material";
function AdminPage() {
  const rooms = useTranslatedRooms();
  const [value, setValue] = useState("");
  const [selectedRoom, setSelectedRoom] = useState<string>("");
const [availabilityDocuments, setAvailabilityDocuments] = useState<any[]>([]);
const [dailyPrices, setDailyPrices] = useState<any[]>([]);
const isTabletOrMobile = useMediaQuery("(max-width: 1090px)");
const [tabValue, setTabValue] = useState(0);
const [activeMonth, setActiveMonth] = useState(new Date()); // Stato globale per il mese
const getRoomTitle = (room: string) => {
  if (room === "room1") return "Inno al Re";
  if (room === "room2") return "Il Barbiere Di Siviglia";
  if (room === "room3") return "L'Osteria Di Marechiaro";
  if (room === "room4") return "La Molinara";
  if (room === "room5") return "Il Matrimonio Inaspettato";
  return "Titolo Sconosciuto";
};
const handleMonthChange = (direction: any) => {
  const newDate = new Date(activeMonth);
  newDate.setMonth(activeMonth.getMonth() + direction); // Cambia mese
  setActiveMonth(newDate); // Aggiorna il mese per tutti i calendari
};
useEffect(() => {
  const loadPrices = async () => {
    if (selectedRoom) {
      const prices = await fetchDailyPrices(selectedRoom);
      setDailyPrices(prices);
    }
  };
  loadPrices();
}, [selectedRoom]);
useEffect(() => {
  const fetchDocuments = async () => {
    const documents = await fetchAvailabilityDocuments(value);
    setAvailabilityDocuments(documents);
  };
  fetchDocuments();
}, [value, tabValue]);

const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
  setTabValue(newValue);
};
return (
  <Box
    sx={{
      width: "100vw",
      // minHeight: "100vh",
      display: "flex",
      backgroundColor: "#121212",
      flexDirection: "column",
    }}
  >
    <Box sx={{ flex: 1, overflow: "auto" }}>
      {tabValue === 0 && (
        <CalendarBooking
          activeMonth={activeMonth}
          availabilityDocuments={availabilityDocuments}
          isColor={false}
          isList={false}
        />
      )}
      {tabValue === 1 && (
        <CalendarBooking
          isList={true}
          activeMonth={activeMonth}
          availabilityDocuments={availabilityDocuments}
          isColor={false}
        />
      )}
      {tabValue === 2 && (
        <TabManageBookings
          tabValue={tabValue}
          availabilityDocuments={availabilityDocuments}
          isTabletOrMobile={isTabletOrMobile}
          rooms={rooms}
        />
      )}
      {tabValue === 3 && (
        <TabManageBookings
          tabValue={tabValue}
          availabilityDocuments={availabilityDocuments}
          isTabletOrMobile={isTabletOrMobile}
          rooms={rooms}
        />
      )}

      {tabValue === 4 && (
        <Box
          sx={{
            p: 1,
            height: "240vw",
          }}
        >
          {" "}
          <div
            style={{
              display: "flex",
              color: "white",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "20px 20px",
            }}
          >
            <button onClick={() => handleMonthChange(-1)}>{"<"}</button>
            <h2 style={{ margin: "0 10px" }}>
              {activeMonth.toLocaleDateString("it-IT", {
                month: "long",
                year: "numeric",
              })}
            </h2>
            <button onClick={() => handleMonthChange(1)}>{">"}</button>
          </div>{" "}
          <Stack
            direction="row"
            flexWrap="wrap"
            justifyContent="center"
            sx={{
              width: "100%",
              margin: "0 auto",
              maxWidth: "500px",
            }} // Assicurati che il contenitore sia largo il 100%
          >
            <Grid container spacing={1}>
              {rooms.length > 1 &&
                // Fai il reverse dell'array rooms prima di mappare
                rooms
                  .slice() // Usa .slice() per evitare di modificare l'array originale
                  .reverse()
                  .map((roomId) => {
                    return (
                      <Grid item xs={6} key={roomId.numero}>
                        {/* Due calendari per riga */}
                        <Box
                          sx={{
                            backgroundColor: "#2848b9",
                          }}
                        >
                          <Typography
                            variant="h6"
                            sx={{
                              color: "white",
                              fontSize: "14px",
                              letterSpacing: 1.3,
                            }}
                          >
                            {getRoomTitle(roomId.numero)}
                          </Typography>
                        </Box>
                        <CalendarBooking
                          isList={false}
                          activeMonth={activeMonth}
                          availabilityDocuments={availabilityDocuments.filter(
                            (doc) => doc.roomId === roomId.numero
                          )}
                          isColor={true}
                        />
                      </Grid>
                    );
                  })}
            </Grid>
          </Stack>
        </Box>
      )}
    </Box>

    {/* Toolbar in basso con Tabs */}
    <Box
      sx={{
        position: "fixed",
        display: "flex",
        color: "white",
        justifyContent: "center",
        bottom: 0,

        width: "100%",
        backgroundColor: "#313131",
        borderTop: "1px solid #e0e0e0",
      }}
    >
      <Tabs
        sx={{
          // Set a maximum width for the Tabs to avoid overflow
          maxWidth: "100%",
          overflow: "hidden",
        }}
        value={tabValue}
        onChange={handleTabChange}
        textColor="inherit"
        indicatorColor="primary"
        variant="scrollable" // Enable horizontal scrolling if tabs exceed width
        scrollButtons="auto" // Show scroll buttons automatically when needed
      >
        <Tab
          label=""
          icon={<FormatListBulletedIcon fontSize="small" />} // Set icon size to small
          sx={{
            color: tabValue === 0 ? "#2196F3" : "#d0d7db",
            minWidth: 65, // Set a minimum width for each tab
          }}
        />
        <Tab
          label=""
          icon={<FilterListIcon fontSize="small" />}
          sx={{
            color: tabValue === 1 ? "#2196F3" : "#d0d7db",
            minWidth: 65,
          }}
        />
        <Tab
          label=""
          icon={<AddIcon fontSize="small" />}
          sx={{
            color: tabValue === 2 ? "#2196F3" : "#d0d7db",
            minWidth: 65,
          }}
        />
        <Tab
          label=""
          icon={<EuroSymbol fontSize="small" />}
          sx={{
            color: tabValue === 3 ? "#2196F3" : "#d0d7db",
            minWidth: 65,
          }}
        />
        <Tab
          label=""
          icon={<CalendarMonthIcon fontSize="small" />}
          sx={{
            color: tabValue === 4 ? "#2196F3" : "#d0d7db",
            minWidth: 65,
          }}
        />
      </Tabs>
    </Box>
  </Box>
);
}

export default AdminPage;
